import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Button, Card, Empty, Table, Tag } from 'antd'
import moment from 'moment'
import { getRequest, dutyFollowUpDealerInterestUrl } from '../../../config'

// The customers who said "Yes, set me up" to dealer pricing (spec: duty-follow-up-messages, w-admin
// Req 3.3-3.4). Nobody is registered automatically — the price is the owner's decision — so each row
// opens the Dealers form with the phone already filled in.
const DealerInterestTable = () => {
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [rows, setRows] = useState([])

  useEffect(() => {
    const load = async () => {
      const response = await getRequest(dutyFollowUpDealerInterestUrl, 'dealer interest', setLoading)
      if (response.success) setRows(response.data || [])
    }
    load()
  }, [])

  /* eslint-disable react/display-name */
  const columns = [
    { title: 'Customer', dataIndex: 'customer', key: 'customer' },
    { title: 'Paid checks', dataIndex: 'paidChecks', key: 'paidChecks' },
    {
      title: 'Said yes',
      dataIndex: 'answeredAt',
      key: 'answeredAt',
      render: (_, r) => (r.answeredAt ? moment(r.answeredAt).fromNow() : '—')
    },
    {
      title: 'Dealer',
      key: 'registered',
      render: (_, r) =>
        r.registeredNow ? (
          <Tag color="green">Registered</Tag>
        ) : (
          <Button
            size="small"
            type="primary"
            disabled={!r.phone}
            onClick={() =>
              history.push(
                `/duty-assistant/dealers?new=1&phone=${encodeURIComponent(r.phone)}`
              )
            }
          >
            Register as dealer
          </Button>
        )
    },
    {
      title: 'Conversation',
      key: 'conversation',
      render: (_, r) =>
        r.conversationId ? (
          <Link to={`/duty-assistant/conversations/${r.conversationId}`}>Open</Link>
        ) : (
          '—'
        )
    }
  ]
  /* eslint-enable react/display-name */

  return (
    <Card title="Dealer interest" style={{ marginTop: 16 }}>
      <Table
        rowKey="id"
        loading={loading}
        columns={columns}
        dataSource={rows}
        pagination={false}
        locale={{
          emptyText: <Empty description="Nobody has said yes to dealer pricing yet." />
        }}
      />
    </Card>
  )
}

export default DealerInterestTable
